@use '@/scss/underscore' as _;

.icon {
  flex-shrink: 0;
}

.chargeNotification {
  margin-top: _.unit(4);
}
